import React from 'react';
import { MimaButton, MimaText, Modal } from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import { inventoryStore } from '../../stores';
import moment from 'moment';

const ActivityTrail = ({ closeModal }) => {
    const stockList = inventoryStore.selectedStock.audits;

    return (
        <Modal closeModal={closeModal}>
            <MimaText variant="subtitleBold" mb={5}>Activity Trail</MimaText>
            {stockList.map(x => (
                <div key={x._id} className={styles.card}>
                    <div className={styles.card_top}>
                        <MimaText variant="small" mb={1.5}>{`${x?.user?.firstname} ${x?.user?.lastname}`}</MimaText>
                        <MimaText variant="small" mb={1.5}>{moment(x?.createdAt).format("DD/MM/YYYY, h:mm a")}</MimaText>
                    </div>
                    <MimaText variant="small" mb={1.5}>Action: Updated Quantity</MimaText>
                    <MimaText variant="small" >{`Reason: ${x.reason}`}</MimaText>
                </div>
            ))}


            <MimaButton
                title="Close"
                onClick={closeModal}
                buttonColor="var(--color-dark)"
                mt={4}
            />
        </Modal>
    )
}
export default ActivityTrail;